// extracted by mini-css-extract-plugin
export var attachment = "_sj-a";
export var emailContainer = "_sj-4";
export var emailContentPaddedContainer = "_sj-b";
export var emailHeader = "_sj-6";
export var emailIframe = "_sj-3";
export var emailInfoIcon = "_sj-9";
export var emailShortenedSummary = "_sj-e";
export var infoDropdown = "_sj-0";
export var infoRowBoundedContent = "_sj-d";
export var internal = "_sj-5";
export var merchant = "_sj-8";
export var messageInputContainer = "_sj-h";
export var normal = "_sj-7";
export var replyCard = "_sj-f";
export var subtleButton = "_sj-1";
export var subtleButtonIconContainer = "_sj-2";
export var toggleViewRepliesButton = "_sj-c";
export var wrappingText = "_sj-g";